import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts'
import 'normalize.css/normalize.css'
import App from './App.vue'
import router from './router'
import store from './store'

// ↓↓↓ 加这三行 ↓↓↓
import axios from 'axios'
axios.defaults.baseURL = 'https://cloud1-d9gm0o30kd04886fd-1466246860.ap-shanghai.app.tcloudbase.com/mall-gateway'
Vue.prototype.$axios = axios

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')